// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '유유제약',
  targetSheetName: '수수료율표',
  headerRowIndex: 6,
  headerRowCount: 1,
  dataStartRowIndex: 7,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '보험약가',
    commissionRate: '수수료율',
    commissionNote: '비고',
  },
  requiredHeaders: [
    'No',
    '분류',
    '성분',
    '보험코드',
    '제품명',
    '보험약가',
    '수수료율',
    '생동/임상여부',
    '자사/위탁',
    '비고',
  ],
});
